import { createFeature, createReducer, on } from '@ngrx/store';

import * as WaterAuthoritiesActions from './water-authorities.actions';
import { WaterAuthority } from '../models/water-authorities.model';

export interface WaterAuthoritiesState {
  waterAuthorities: WaterAuthority[];
  loading: boolean;
  error: string | null;
}

export const initialState: WaterAuthoritiesState = {
  waterAuthorities: [],
  loading: false,
  error: null,
};

export const waterAuthoritiesFeature = createFeature({
  name: 'waterAuthorities',
  reducer: createReducer(
    initialState,
    on(WaterAuthoritiesActions.loadWaterAuthoritiesRequest, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(WaterAuthoritiesActions.loadWaterAuthoritiesSuccess, (state, { waterAuthorities }) => ({
      ...state,
      waterAuthorities,
      loading: false,
      error: null,
    })),
    on(WaterAuthoritiesActions.loadWaterAuthoritiesFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
    on(WaterAuthoritiesActions.upsertWaterAuthorityRequest, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(WaterAuthoritiesActions.upsertWaterAuthoritySuccess, (state, { waterAuthority }) => ({
      ...state,
      waterAuthorities: state.waterAuthorities.some((wa) => wa.id === waterAuthority.id)
        ? state.waterAuthorities.map((wa) => (wa.id === waterAuthority.id ? { ...wa, ...waterAuthority } : wa))
        : [...state.waterAuthorities, waterAuthority as WaterAuthority],
      loading: false,
      error: null,
    })),
    on(WaterAuthoritiesActions.upsertWaterAuthorityFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
  ),
});
